import { useAuth } from "@/context/AuthContext";
import SecurityPanel from "@/components/SecurityPanel";

export default function SecurityPage() {
  const { user } = useAuth();
  return (
    <div>
      <h1 className="font-serif font-bold text-3xl text-white mb-1">Security</h1>
      <p className="text-slate-400 mb-6">{user.email}</p>
      <SecurityPanel />
    </div>
  );
}
